import { scrollbar } from 'shared/styles/scrollbar';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.SurfaceCultured10};
`;

export const Menu = styled.menu`
  position: fixed;
  top: 0;
  left: 0;
  min-width: 289px;
  width: 20%;
  height: 100vh;
  background: ${({ theme }) => theme.colors.SurfaceIndependence40};
  z-index: 8000;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: max(20%, 289px);
  right: 0;
  height: 70px;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  z-index: 7999;
  border: 1px solid #1a1a291a;
  border-radius: 0 0 8px 8px;
  padding: 0 24px;
  margin-inline: 24px;

  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    left: 0;
    height: 56px;
    margin-inline: 12px;
    padding: 0 12px;
  }
`;

export const MainBlockWrapper = styled.div`
  margin-top: 70px;
  margin-left: max(20%, 289px);
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: calc(100% - max(20%, 289px));
  min-height: calc(100vh - 70px);

  @media (max-width: 768px) {
    margin-top: 56px;
    margin-left: 0;
    width: 100%;
    min-height: calc(100vh - 56px);
  }
`;

export const Content = styled.div`
  flex: 1;
  overflow: auto;
  ${scrollbar(theme)}
`;

export const Footer = styled.div`
  height: 70px;
  display: flex;
  background-color: ${({ theme }) => theme.colors.SurfaceCultured10};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BurgerButton = styled.button`
  display: none;
  @media (max-width: 768px) {
    display: inline-flex;
  }
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #1a1a291a;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  color: ${({ theme }) => theme.colors.DarkBlue};
`;

export const MobileMenuOverlay = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 9000;
`;

export const MobileMenuPanel = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: min(85vw, 320px);
  background: ${({ theme }) => theme.colors.SurfaceIndependence40};
  z-index: 9001;
  overflow-y: auto;
`;
